import request from '@/utils/request'


// 查询设备报警信息列表
export function listDeviceAlarm(query) {
  return request({
    url: '/saifuneng/saifuneng-device-alarm/list',
    method: 'get',
    params: query
  })
}

// 查询设备报警信息分页
export function pageDeviceAlarm(query) {
  return request({
    url: '/saifuneng/saifuneng-device-alarm/page',
    method: 'get',
    params: query
  })
}

// 查询设备报警信息详细
export function getDeviceAlarm(data) {
  return request({
    url: '/saifuneng/saifuneng-device-alarm/detail',
    method: 'get',
    params: data
  })
}

// 新增设备报警信息
export function addDeviceAlarm(data) {
  return request({
    url: '/saifuneng/saifuneng-device-alarm/add',
    method: 'post',
    data: data
  })
}

// 修改设备报警信息
export function updateDeviceAlarm(data) {
  return request({
    url: '/saifuneng/saifuneng-device-alarm/edit',
    method: 'post',
    data: data
  })
}

// 删除设备报警信息
export function delDeviceAlarm(data) {
  return request({
    url: '/saifuneng/saifuneng-device-alarm/delete',
    method: 'post',
    data: data
  })
}

// 查询管线信息列表
export function listPipeline(query) {
  return request({
    url: '/saifuneng/saifuneng-pipeline/list',
    method: 'get',
    params: query
  })
}

// 查询设备信息列表
export function listDevice(query) {
  return request({
    url: '/saifuneng/saifuneng-device/list',
    method: 'get',
    params: query
  })
}
